import { useContext, useMemo } from "react";
import { CmsContext } from "../context";

export const useTosVersion = () => {
  const { pages } = useContext(CmsContext);

  const version = useMemo(() => {
    const termsPage = pages?.find((p) => p.slug === "terms");
    const version = termsPage?.tosVersion;
    return version;
  }, [pages]);

  return version;
};
